"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import React from "react";

import { Button } from "../ui/Button";
import { Typography } from "../ui/Typography";


export const Header: React.FC = () => {
	const isLoginPage = usePathname() === "/login";
	const isSignUpPage = usePathname() === "/sign-up";

	return (
		<header className="h-[100px] w-full flex items-center justify-between px-[6.94%]">
			{/* Logo */}
			<div className="h-[45px] flex items-center">
				<Link href="/">
					<Typography variant="h4" color="blu-medio" className="font-bold">
						Fattiricco
					</Typography>
				</Link>
			</div>

			{/* Navigation */}
			<div className="flex gap-4 items-center">
				{!isLoginPage && (
					<Link href="/login">
						<Button variant="primary">
							Accedi
						</Button>
					</Link>
				)}
				{!isSignUpPage && (
					<Link href="/sign-up">
						<Button variant="outline">
							Registrati
						</Button>
					</Link>
				)}
			</div>
		</header>
	);
};
